import { render, staticRenderFns } from "./OnBilgilendirmeModal.vue?vue&type=template&id=68b12fcb&scoped=true"
import script from "./OnBilgilendirmeModal.vue?vue&type=script&lang=js"
export * from "./OnBilgilendirmeModal.vue?vue&type=script&lang=js"
import style0 from "./OnBilgilendirmeModal.vue?vue&type=style&index=0&id=68b12fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b12fcb",
  null
  
)

export default component.exports